import sliceCreator from '../../index.js';
import {PR_DASHBOARD} from '../../../constants/index.js';
const _prDashboardAction = sliceCreator('PR_DASHBOARD',PR_DASHBOARD, 'get');

const { asyncAction: prDashboardAction, reducer, clearData: clearprDashboardData } = _prDashboardAction;

export default reducer;

export {
    prDashboardAction,
    clearprDashboardData
}


